import React from 'react';
import { TextStatus } from '@cko/primitives';
import { InfoTooltip } from '../../Tooltip';
/**
 * /**
 * @deprecated - This component is made up of TextStatus and Tooltip components from UI Toolkit.
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/textstatus--docs}
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/tooltip--docs}
 */
const StatusWithTooltip = ({ status, tooltip }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(TextStatus, { interactive: false, mr: "var(--layout-soybean)" }, status),
        tooltip && React.createElement(InfoTooltip, { text: tooltip })));
};
export default StatusWithTooltip;
